import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import WorkRow from './WorkRow';
import _ from 'lodash';
import { PsTable } from '../../shared/components/table/PsTable';

export default class WorkTable extends React.Component {

    renderHead() {
        const renderHeadState = (render) => {
            if ( render ) {
                return <th>{I18nUtils.tr('TR_ESTADO')}</th>;
            }
            return null;
        };

        return (
            <tr>
                {renderHeadState(!this.props.hideState)}
                <th>{I18nUtils.tr('TR_CODIGO')}</th>
                <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                {this.props.showContractorColumn && <th>{I18nUtils.tr('TR_CONTRATISTA')}</th>}
                <th>{I18nUtils.tr('TR_FECHA_INICIO')}</th>
                <th>{I18nUtils.tr('TR_FECHA_FIN')}</th>
                <th>{I18nUtils.tr('TR_ACCESO_FICHA')}</th>
            </tr>
        );
    }

    render() {
        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;
        }
        return (
            <PsTable headings={this.renderHead()}>
                {
                    _.map(this.props.data, object =>
                        <WorkRow key={object.id}
                                 work={object}
                                 hideState={this.props.hideState}
                                 showContractorColumn={this.props.showContractorColumn}
                        />,
                    )
                }
            </PsTable>
        );
    }

}

WorkTable.propTypes = {
    data: PropTypes.any.isRequired,
    hideState: PropTypes.bool,
    error: PropTypes.string,
    showContractorColumn: PropTypes.bool,
};
WorkTable.defaultProps = {
    hideState: false,
    showContractorColumn: false,
};



// WEBPACK FOOTER //
// ./src/app/works/components/WorkTable.jsx